/* global Promise Set */

// Third-party imports
import $ from 'jquery';
import _ from 'lodash';

// Local imports
import * as api from './api.js';
import * as constant from '../global/constant.js';
import * as flash from '../util/flash.js';
import * as iter from '../util/iter.js';
import { clearRegion } from './select.js';
import * as slider from './slider.js';
import * as wv from '../global/worldvision.js';

export function initialize(global, custom_data) {
    // init slider
    slider.initialize();
    let spinner = $(`${slider.slider_id_css} + .spinner`);
    let filterdata;

    let shared = {
        add_slides: true,
        spinner: spinner,
        page: new_page(),
        filterdata: filterdata,
        num_slides: 0,
        wait_for_slider: false,
        global: global,
        tocart_callbacks: custom_data.tocart_callbacks,
        collection: custom_data.collection || 'sponsorships',
        page_data: custom_data.page,
        get_filterdata: custom_data.filterdata_callback,
        update_filters: custom_data.update_filters,
    };

    handleInitialState(global, shared);
    handleFutureUpdates(shared);
}

function new_page() {
    return { looped: false, start: 1, end: 1, current: 1, next: 1 };
}

function handleInitialState(global, shared) {
    clearSlider(shared);
    shared.spinner.hide();

    let url_filters = getFiltersFromURL(global);
    setFiltersInDOM(url_filters);
    updateSlider(shared, {
        clearResults: true,
        filters: url_filters,
        init: true,
    });
}

function handleFutureUpdates(shared) {
    // Handle DOM filter changes
    filterChanged(() => {
        updateSlider(shared, {
            clearResults: true,
            filters: getFiltersFromDOM(),
            init: true,
        });
    });

    // Push new sponsorships to slider as needed
    slider.shouldLoadMore(shared, end => {
        $('.spinner').show();
        $(slider.slider_id_css).fadeTo('fast', 0.05);
        updateSlider(shared, {
            clearResults: false,
            filters: getFiltersFromDOM(),
            slider_end: end,
        });
    });

    // Reset Filters
    let all_el = ['#resetfilter', '#resetfilter0'];
    let doc = shared.global.document;
    for (let el of all_el.map(s => doc.querySelector(s))) {
        if (el === null) {
            continue;
        }
        el.addEventListener('click', event => {
            event.preventDefault();
            let filters = shared.update_filters(getDefaultFiltersObject());
            setFiltersInDOM(filters);
            updateSlider(shared, {
                clearResults: true,
                filters: shared.update_filters({}),
                init: true,
            });
        });
    }
}

async function updateSlider(shared, params) {
    if (params.init) {
        shared.page = new_page();
    }

    if (params.clearResults) {
        setPagination(shared, params.filters, async () => {
            await fetchSponsorships(shared, params);
        });
    } else {
        let page = shared.page;

        if (!page.looped || page.next !== page.start) {
            page.next++;
        }

        if (page.next > page.end) {
            page.next = 1;
        }

        if (page.next !== page.start) {
            await fetchSponsorships(shared, params);
        } else {
            if (!page.looped) {
                page.looped = true;
            }
            $(slider.slider_id_css).fadeTo('fast', 1);
            $('.spinner').hide();
        }
    }
}

function setPagination(shared, filters, cb) {
    api.get_collection({
        filters: filters,
        collection: shared.collection,
        cb: async response => {
            updateCounter(response.total_sponsorships);
            let endPage = response.total_pages;

            // Don't choose the last page which will likely have fewer than 8
            // sets of data; with ~< 5 sets of data, further slides will not be
            // able to be loaded (slides are only loaded when the current slide
            // is 2 away from either end of the slider.
            let currentPage = random(1, endPage - 1);

            let nextPage = currentPage + 1;
            if (nextPage === endPage) {
                nextPage--;
            } else if (nextPage > endPage) {
                // This branch will only be entered when there is only a single
                // slide to load into the slider.
                nextPage = currentPage;
            }

            shared.page = {
                looped: false,
                start: currentPage,
                end: endPage,
                current: currentPage,
                next: nextPage,
            };

            await cb();
        },
    });
}

function updateCounter(count) {
    let dataDiv = $('.sponsorship-data');
    let allChildren = dataDiv.data('all-children');

    // If there is no collection (eg the events app page), then allChildren will
    // always be an empty string. This ensures that allChildren is set to the
    // total number of children found on first fetch of sponsorships.
    if (allChildren === '') {
        dataDiv[0].dataset.allChildren = `${count}`;
        allChildren = count;
        $('.sponsorshipCount--all .sponsorshipCount-number').html(count);
    }

    if (count < 0) {
        let errmsg = `updateCounter expected count >= 0, got ${count} instead`;
        throw new Error(errmsg);
    } else if (count === 1) {
        $('.sponsorshipCount--single').show();
        $('.sponsorshipCount--multiple').hide();
        $('.sponsorshipCount--all').hide();
        $('.sponsorshipCount--single .sponsorshipCount-number').html(count);
    } else if (count > 1) {
        allChildren = parseInt(allChildren);
        if (count < allChildren) {
            $('.sponsorshipCount--multiple').show();
            $('.sponsorshipCount--single').hide();
            $('.sponsorshipCount--all').hide();
            let selector =
                '.sponsorshipCount--multiple .sponsorshipCount-number';
            $(selector).html(count);
        } else {
            $('.sponsorshipCount--all').show();
            $('.sponsorshipCount--multiple').hide();
            $('.sponsorshipCount--single').hide();
        }
    } else {
        $('.sponsorshipCount--single').hide();
        $('.sponsorshipCount--multiple').hide();
        $('.sponsorshipCount--all').hide();
    }
}

function _process_spsh_data(shared, params, spsh_data) {
    let num_added = 0;
    let slides = shuffle(spsh_data);
    let slider_obj = $(slider.slider_id_css).data('sliderPro');
    let cur_index = slider_obj.getSelectedSlide();
    let new_index = cur_index;
    if (params.slider_end === slider.SliderEnd.HEAD) {
        num_added = slider.insertSlides(shared, slides);
        new_index = cur_index + num_added;
        shared.wait_for_slider = true;
        slider_obj.gotoSlide(new_index);
    } else {
        let shared_data = {
            global: shared.global,
            tocart_callbacks: shared.tocart_callbacks,
            page_data: shared.page_data,
        };
        num_added = slider.addSlides(shared_data, slides);
    }

    // Move to the slider's initial position if this adding of slides is
    // being done on init
    if (params.init) {
        slider.initial_position(shared);
    }

    shared.num_slides += num_added;
    if (!shared.wait_for_slider) {
        $(slider.slider_id_css).fadeTo('fast', 1);
        $('.spinner').hide();
    }
}

// Private helper function for fetchSponsorships
function _get_collection_arg(shared, params) {
    let data = {
        filters: params.filters,
        page: shared.page.next,
        collection: shared.collection,
        cb: async response => {
            let resp_spsh = response.sponsorships;
            let has_data = Boolean(resp_spsh.length);

            // Don't clear slider if there are no results (this is because the
            // slider doesn't support having 0 slides, will throw exceptions
            // in this case)
            if (slider.shouldClear() && has_data) {
                slider.clearSlides(shared);
                shared.num_slides = 0;
            }
            if (has_data) {
                _process_spsh_data(shared, params, resp_spsh);
            }

            if (params.clearResults) {
                if (has_data) {
                    hideNoResults(shared.global);
                } else {
                    showNoResults(shared.global);
                }
            }
        },
    };
    return data;
}

async function fetchSponsorships(shared, params) {
    if (params.clearResults) {
        clearSlider(shared);
        hideNoResults(shared.global);
        flash.hide();
        clearRegion();
    }

    let promises = [];
    let set_filterdata;
    if (!shared.filterdata) {
        set_filterdata = async (shared, params) => {
            shared.filterdata = await shared.get_filterdata(shared.global);
            parseFilterOptions(shared.filterdata, params.filters);
        };
    } else {
        set_filterdata = async (shared, params) => {
            parseFilterOptions(shared.filterdata, params.filters);
        };
    }
    promises.push(set_filterdata(shared, params));
    let data = _get_collection_arg(shared, params);
    promises.push(api.get_collection(data));

    await Promise.all(promises);
}

class FilterOptionsParser {
    constructor(filterdata, selectedfilters) {
        // selectedfilters is cloned so that the possible removal of
        // special_event_id is not propagated to the actual filter object
        let clsargs = {
            filterdata: filterdata,
            selectedfilters: Object.assign({}, selectedfilters),
        };
        this.clsargs = clsargs;

        this.mydata = this.init_mydata(clsargs);
        this.filterarr = this.init_filterarr();
    }

    init_mydata(clsargs) {
        // special_event_id isn't represented as a select drop down, so remove
        // it from the filter object.
        let selectedfilters = clsargs.selectedfilters;
        if ('special_event_id' in selectedfilters) {
            delete selectedfilters.special_event_id;
        }

        let mydata = [];
        if (Object.keys(selectedfilters).length === 0) {
            mydata = clsargs.filterdata;
        } else {
            for (let [key, val] of Object.entries(selectedfilters)) {
                let arr = {};
                if (key === 'favorite_subject' || key === 'country') {
                    arr[key] = _.startCase(val);
                } else {
                    arr[key] = val;
                }

                if (mydata.length > 0) {
                    mydata = mydata.filter(this.filter_collection(arr, key));
                } else {
                    mydata = clsargs.filterdata.filter(
                        this.filter_collection(arr, key)
                    );
                }
            }
        }
        return mydata;
    }

    // Strips any accents from the filter data, and replaces all hyphens with a space. This is done
    // only on the data inside of the filter object which is created from the OSPChildSearchFilter.js.
    // This is needed as the values we store on the front end goes through many lodash formatters
    // and no longer match the value that is stored inside of the filter file.
    // So we strip any accents, replace hyphens, and lower case everything before doing the comparison
    filter_collection(arr, key) {
        return function(data) {
            if (!data[key]) {
                return;
            }
            let dataValue = data[key]
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace('-', ' ');
            let filterValue = arr[key]
                .toLowerCase()
                .normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace('-', ' ');
            if (dataValue === filterValue) {
                return data;
            }
        };
    }

    init_filterarr() {
        let filterarr = [];
        filterarr['birthyear'] = [];
        filterarr['birthyear']['options'] = [];

        filterarr['month'] = [];
        filterarr['month']['options'] = [];

        filterarr['favorite_subject'] = [];
        filterarr['favorite_subject']['options'] = [];

        filterarr['birthday'] = [];
        filterarr['birthday']['options'] = [];

        filterarr['lang'] = [];
        filterarr['lang']['options'] = [];

        filterarr['age'] = [];
        filterarr['age']['options'] = [];

        filterarr['country'] = [];
        filterarr['country']['options'] = [];

        filterarr['longest_waiting'] = [];
        filterarr['longest_waiting']['options'] = [];
        return filterarr;
    }

    filter() {
        let filterarr = this.filterarr;
        let mydata = this.mydata;
        for (let i = 0; i < mydata.length; i++) {
            filterarr['birthyear']['options'][mydata[i]['birthyear']] =
                mydata[i]['birthyear'];
            filterarr['birthyear']['type'] = 'int';

            filterarr['month']['options'][mydata[i]['month']] =
                mydata[i]['month'];
            filterarr['month']['type'] = 'int';

            filterarr['birthday']['options'][mydata[i]['birthday']] =
                mydata[i]['birthday'];
            filterarr['birthday']['type'] = 'int';

            filterarr['age']['options'][mydata[i]['age']] = mydata[i]['age'];
            filterarr['age']['type'] = 'int';

            filterarr['longest_waiting']['options'][
                mydata[i]['longest_waiting']
            ] = mydata[i]['longest_waiting'];
            filterarr['longest_waiting']['type'] = 'string';

            if (
                filterarr['favorite_subject']['options'].indexOf(
                    mydata[i]['favorite_subject']
                ) === -1 &&
                mydata[i]['favorite_subject'] !== null
            ) {
                filterarr['favorite_subject']['options'].push(
                    mydata[i]['favorite_subject']
                );
            }

            if (
                filterarr['lang']['options'].indexOf(mydata[i]['lang']) === -1
            ) {
                filterarr['lang']['options'].push(mydata[i]['lang']);
            }

            if (
                filterarr['country']['options'].indexOf(
                    mydata[i]['country']
                ) === -1
            ) {
                filterarr['country']['options'].push(mydata[i]['country']);
            }

            filterarr['favorite_subject']['type'] = 'string';
            filterarr['lang']['type'] = 'string';
            filterarr['country']['type'] = 'string';
        }
        let filterobj = Object.assign({}, filterarr);
        setFilterOptions(filterobj, this.clsargs.selectedfilters);
    }
}

function parseFilterOptions(filterdata, selectedfilters) {
    let parser = new FilterOptionsParser(filterdata, selectedfilters);
    parser.filter();
}

function setFilterOptions(filterOptions, selectedFilters) {
    Object.keys(filterOptions).forEach(filter => {
        if (filter === 'special_event_id') {
            return;
        }
        let type = filterOptions[filter].type;
        let options = filterOptions[filter].options;
        if (type === 'int') {
            options = options.map(option => parseInt(option, 10));
            options = options.sort((a, b) => a - b);
        } else if (type === 'string') {
            options = options.sort();
        }
        let target = $(constant.FILTER_SELECTORS[filter]);
        let firstOption = target.children()[0];
        if (options.length) {
            let selectedFilter = selectedFilters[filter];
            target.empty().append(firstOption);
            options.forEach(option => {
                let selected = false;
                if (_.kebabCase(option) === _.kebabCase(selectedFilter)) {
                    selected = true;
                }
                let displayValue = option;
                if (filter === 'month') {
                    displayValue = target.data(String(option));
                }
                // The option value is kebab cased below, which matches the value in the
                // collection.filter-endpoint.liquid file.
                let optsel = selected ? 'selected="selected"' : '';
                let optstr = `
                    <option value="${_.kebabCase(option)}" ${optsel}>
                        ${displayValue}
                    </option>
                `;
                target.append(optstr);
            });
        }
    });
}

function filterChanged(cb) {
    Object.keys(constant.FILTER_SELECTORS).forEach(filterName => {
        let selector = $(constant.FILTER_SELECTORS[filterName]);
        selector.on('change', cb);
    });
}

function getFiltersFromURL(global) {
    let real_url_params = wv.get_obj(global, 'url_params') || {};
    let storeLanguage = global.document.body.dataset.lang;
    //For sponsorship page if url does not have any params to filter and
    // store is FR then filter the sponsorship page with language:FR if we have google analytics tags also ignore and select 
    //FR as in the language for sponsorship page
    if (
        (Object.keys(real_url_params).length === 0 &&  storeLanguage.toLowerCase() === 'fr') || 
        (Object.keys(real_url_params).length === 1  && 
        ('_ga' in real_url_params || '_gl' in real_url_params ) &&
        storeLanguage.toLowerCase() === 'fr')
    ) {
        real_url_params = { lang: 'FR' };
    }
    let url_params = Object.assign({}, real_url_params);

    // Since spsh products gets tagged with "special_event_id", but the url
    // parameter key is named "eventid", need to detect and translate this
    // key.
    //
    // TODO: consider changing the shopify job processor code to use
    // "eventid" as the tag name instead so the following conditional can be
    // removed
    if ('eventid' in url_params) {
        url_params.special_event_id = url_params.eventid;
        delete url_params.eventid;
    }

    let valid = {};
    Object.keys(url_params).forEach(filter => {
        if (constant.FILTER_SELECTORS[filter]) {
            valid[filter] = url_params[filter];
        }
    });
    return valid;
}

function setFiltersInDOM(filters) {
    Object.keys(filters).forEach(filterName => {
        let selector = constant.FILTER_SELECTORS[filterName];
        let value = filters[filterName];
        if (filterName === 'gender') {
            selector += '[value="' + value + '"]';
            $(selector).prop('checked', true);
            $(selector)
                .closest('.radio--blockStyle')
                .addClass('js-hasValue');
        } else if (filterName === 'special_event_id') {
            document.querySelector(selector).dataset.value = value;
        } else if (filterName === 'longest_waiting') {
            // eslint-disable-next-line quotes
            if (value === 'true' || value === '"true"' || value === "'true'") {
                $(selector).prop('checked', true);
            } else {
                $(selector).prop('checked', false);
            }
        } else {
            if (selector) {
                $(selector).val(value);
            }

            if (!value) {
                $(selector).removeClass('js-hasValue');
            }
        }
    });
}

function getFiltersFromDOM() {
    let filters = {};
    Object.keys(constant.FILTER_SELECTORS).forEach(function(filterName) {
        let selector = constant.FILTER_SELECTORS[filterName];
        let value;

        if (filterName === 'gender') {
            selector += ':checked';
        }

        // This needs to be special cased as this filter is represented as a
        // dataset div instead of a select
        if (filterName === 'special_event_id') {
            value = $(selector)[0].dataset.value;
        } else if (filterName === 'longest_waiting') {
            // We only want to apply this filter if it's checked
            let isChecked = $(selector).prop('checked');
            if (isChecked) {
                value = 'true';
            }
        } else {
            value = $(selector).val();
        }

        if (value) {
            filters[filterName] = value;
        }
    });
    return filters;
}

function getDefaultFiltersObject() {
    let defaultFilters = {};
    Object.keys(constant.FILTER_SELECTORS).forEach(filterName => {
        defaultFilters[filterName] = '';
    });
    return defaultFilters;
}

function clearSlider(shared) {
    slider.clearSlides(shared);
    let shared_data = {
        global: shared.global,
        tocart_callbacks: shared.tocart_callbacks,
        page_data: shared.page_data,
    };
    let num_added = slider.addSlides(shared_data, [
        null,
        null,
        null,
        null,
        null,
        null,
        null,
    ]);
    shared.num_slides = num_added;
}

function hideNoResults(global) {
    let doc = global.document;
    doc.querySelector(slider.slider_id_css).classList.remove('u-hide');
    doc.querySelector('.sponsorPage-noResults').classList.add('u-hide');
    doc.querySelector('#resetfilter0').classList.remove('u-hide');
}

function showNoResults(global) {
    let doc = global.document;
    doc.querySelector(slider.slider_id_css).classList.add('u-hide');
    doc.querySelector('.sponsorPage-noResults').classList.remove('u-hide');
    doc.querySelector('#resetfilter0').classList.add('u-hide');
    clear_unselected_filters(global);
}

function clear_unselected_filters(global) {
    let doc = global.document;
    let ignore = new Set(['gender', 'special_event_id']);
    for (let [key, select_id] of Object.entries(constant.FILTER_SELECTORS)) {
        // Ignore filter widgets that are not select drop downs
        if (ignore.has(key)) {
            continue;
        }

        let nodes = doc.querySelectorAll(`${select_id} > option`);
        let num_nodes = nodes.length;

        for (let i of iter.range(num_nodes, 1)) {
            let cur = nodes[i];
            if (!cur.selected) {
                cur.remove();
            }
        }
    }
}

function random(from, to) {
    return Math.floor(Math.random() * to) + from;
}

function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
    return array;
}
